import { __generator } from "tslib";
import { fork, all } from 'redux-saga/effects';
import changeScreen from './changeScreen';
import cookies from './cookies';
import downloadAssets from './downloadAssets';
import flashHotspots from './flashHotspots';
import handoffZoomFit from './handoffZoomFit';
import historyBack from './historyBack';
import loadCode from './loadCode';
import loadHotspots from './loadHotspots';
import preloadImages from './preloadImages';
import loadProject from './loadProject';
import loadThumbnails from './loadThumbnails';
import location from './location';
import pusher from './pusher';
import reloadImages from './reloadImages';
import screenTimer from './screenTimer';
import setDefaultCodeLang from './setDefaultCodeLang';
import setEmbedlyContainerHeight from './setEmbedlyContainerHeight';
import showCopying from './showCopying';
import showScreenInfo from './showScreenInfo';
import triggerAssetDownload from './triggerAssetDownload';
import watchHoverOut from './hover';
import replayEvents from './replay';
import trackMouse from './trackMouse';
import loadCanvas from './loadCanvas';
import { createEnhancedHistory } from '../utils/history';
export default function root(dispatch, isAppBuild, isDownloaded) {
    var history, sagas;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                history = createEnhancedHistory({ isAppBuild: isAppBuild, isDownloaded: isDownloaded });
                window.enhancedHistory = history;
                sagas = [
                    fork(changeScreen),
                    fork(cookies),
                    fork(downloadAssets, dispatch),
                    fork(flashHotspots),
                    fork(handoffZoomFit),
                    fork(historyBack, history),
                    fork(loadCanvas),
                    fork(loadCode),
                    fork(loadHotspots),
                    fork(preloadImages, dispatch),
                    fork(loadProject),
                    fork(loadThumbnails, dispatch),
                    fork(location, dispatch, history),
                    fork(reloadImages, dispatch),
                    fork(pusher, dispatch),
                    fork(screenTimer),
                    fork(setDefaultCodeLang),
                    fork(setEmbedlyContainerHeight),
                    fork(showCopying),
                    fork(showScreenInfo),
                    fork(triggerAssetDownload),
                    fork(watchHoverOut),
                    fork(replayEvents),
                    fork(trackMouse),
                ];
                return [4 /*yield*/, all(sagas)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
